import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API } from './config'; 
import * as XLSX from 'xlsx';
import Loader from './Loader';
const Role = () => {
    const [members, setMembers] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [searchMembers, setSearchMembers] = useState('')
    const [loading, setLoading] = useState(false)

    // Fetch member data
    const getMembersDetails = async () => {
        setLoading(true)
        try {
            const res = await axios.get(`${API}?action=getadmin`);
            const membersData = Object.values(res?.data?.data || []);
            setMembers(membersData);
            setLoading(false)

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        getMembersDetails();
    }, []);

    // Filter members based on search term
    const filteredMembers = members.filter(member =>
    (`${member?.title} ${member?.first_name} ${member?.second_name} ${member?.last_name}`.toLowerCase().includes(searchMembers.toLowerCase()) ||
        member?.mobile?.toLowerCase().includes(searchMembers.toLowerCase()) ||
        member?.pradeshname?.toLowerCase().includes(searchMembers.toLowerCase()) ||
        member?.mandalname?.toLowerCase().includes(searchMembers.toLowerCase()))
    );

    // Calculate pagination data
    const totalPages = Math.ceil(filteredMembers.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredMembers.slice(startIndex, startIndex + itemsPerPage);

    // Pagination Handlers
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    // xl format
    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(paginatedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Members');
        XLSX.writeFile(workbook, 'members.xlsx');
    };

  
    return (
        <>
            {loading &&
                <Loader />
            }

            <div className='mt-4 rounded-4' style={{ width: '95%', margin: 'auto', background: '#fff', overflow: 'hidden' }}>
                <div className='text-start p-3'>
                    <div class='d-flex align-items-center justify-content-between gap-2 flex-nowrap'>
                        <div class=''>
                            <p className='fs-3 fw-bold'>Role's</p>
                        </div>
                        <div className='d-flex align-items-center  gap-2'>
                            <input type="text" className='form-control rounded-5  ' placeholder="Search...." onChange={(e) => setSearchMembers(e?.target?.value)} />
                            <p className='fs-3' style={{ cursor: 'pointer' }}><i className="bi bi-plus-circle"></i></p>
                            <p className='fs-3' style={{ cursor: 'pointer' }} onClick={downloadExcel}><i className="bi bi-arrow-up-right-circle"></i></p>
                        </div>
                    </div>
                    {/* Table */}
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <table class='table mt-3 '   >
                            <thead >
                                <tr>
                                    <th class='text-nowrap '> Emails</th>
                                    <th class='text-nowrap'>Mobile</th>
                                    <th class='text-nowrap'>Status</th>
                                    <th class='text-nowrap'>Role</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedData.map((member, index) => (
                                    <tr key={index}>
                                        <td>{member?.email || "-"}</td>
                                        <td>{member.mobile || "-"}</td>
                                        <td>{member.status || "-"}</td>
                                        <td>{member.role || "-"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div class='d-flex align-items-center justify-content-between flex-wrap gap-3'>

                        {/* Pagination Controls */}
                        <div class='d-flex align-items-center gap-3'>
                            <button class='btn btnBlue py-2 ' onClick={handlePrevPage} disabled={currentPage === 1}>
                                <i class="bi bi-caret-left-fill"></i>
                            </button>
                            <span class=' '>Page {currentPage} of {totalPages}</span>
                            <button class='btn btnBlue py-2 ' onClick={handleNextPage} disabled={currentPage === totalPages}>
                                <i class="bi bi-caret-right-fill"></i>
                            </button>
                        </div>

                        {/* Items Per Page Selector */}
                        <div class='d-flex align-items-center  gap-3' >
                            <label class=' '>Items per page: </label>
                            <select class="form-select"
                                value={itemsPerPage}
                                onChange={(e) => setItemsPerPage(Number(e.target.value))}
                                style={{ width: '100px' }}
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                            </select>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

export default Role;
